import { isPlatformBrowser } from '@angular/common';
import { environment } from '../environments/environment';

export function getSubdomain(platformId: object): string | null {
  if (!isPlatformBrowser(platformId)) {
    return null;
  }
  const hostname = window.location.hostname;
  if (hostname === 'localhost' || hostname.endsWith('.localhost')) {
    const hostnameParts = hostname.split('.');
    if (hostnameParts.length > 1 && hostnameParts[0] !== 'localhost') {
      return hostnameParts[0];
    }
    return null;
  }
  const baseDomain = environment.webSiteDomain;
  try {
    const { hostname: currentHostname } = new URL(window.location.href);
    const baseDomainParts = baseDomain.split('.');
    const hostnameParts = currentHostname.split('.');
    if (
      hostnameParts.length > baseDomainParts.length &&
      hostnameParts.slice(-baseDomainParts.length).join('.') === baseDomain
    ) {
      const subdomainParts = hostnameParts.slice(0, -baseDomainParts.length);
      if (subdomainParts.length) {
        return subdomainParts.join('.');
      }
    }
    return null;
  } catch {
    return null;
  }
}
